import { uuidv4 } from '@utils/random'
import Script from 'next/script'
import { ReactNode } from 'react'

const ParticleChart = ({ children }: { children: ReactNode }) => {
	return (
		<Script defer async id={`article-script-${uuidv4()}`} strategy="lazyOnload">
			{`Highcharts.setOptions({
                lang: {thousandsSep: ","},
                navigation: {
                    buttonOptions: { enabled: false }
                }
            });`}
			{children}
		</Script>
	)
}
export default ParticleChart
